import { Injectable, inject } from '@angular/core';
import { GamesService } from './games.service';
import { SsApiService } from '../api/ss-api.service';
import {Observable, ReplaySubject} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators';
import { FiltersService } from '../filters.service';

@Injectable({
  providedIn: 'root'
})
export class LastPlayedGamesService {
  private _api = inject(SsApiService);
  private _filters = inject(FiltersService);


  /**
   * Access to GamesService
   */
  private _games: GamesService;

  /**
   * Emit providers list for last-played games
   */
  public lastPlayedProviders$: ReplaySubject<number[]> = new ReplaySubject<number[]>(1);

  /**
   * For avoiding circular dependency
   */
  set gamesService(service: GamesService) {
    this._games = service;
  }

  /**
   * Returns ready to use favorite games list
   */
  getMappedGameList(): Observable<any> {
    let idList: any[] = [];

    return this._api.playerPlayedGames().pipe(
      map(response => (response || []).map((game: any) => game.identifier)),
      switchMap(identifiers => {
        idList = identifiers;
        return this._games.list({
          'external_id[]': identifiers.length ? identifiers : null,
        });
      }),
      map((response: any) => ({
        ...response,
        gameList: this._filters.sortByArrayOrder(idList, 'externalId', response.gameList)
      })),
      tap(res => this.lastPlayedProviders$.next(res && res.gameList && res.gameList.map(game => game.providerId)))
    );
  }
}
